module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-31.3dda95e8.png";